import $ from "jquery";
import * as bootbox from "bootbox";
import moment from "moment";
// @todo : A gérer avec jQuery dans commonController ?
import "bootstrap-notify";
import "bootstrap-multiselect";
import "eonasdan-bootstrap-datetimepicker";
import * as kendo from "@progress/kendo-ui/js/kendo.grid.js";
import "@progress/kendo-ui/js/kendo.datetimepicker.js";
import "@progress/kendo-ui/js/kendo.timepicker.js";
import { resizeScreen } from "DMS/Utils/resizeScreen";
import { encodeParam, decodeParam } from "DMS/Utils/parameter";
import { processUpdate } from "DMS/Utils/processLauncher";
import { empty } from "DMS/Utils/lib";
import { confirmAction } from "DMS/Controllers/commonController";
import { initField, clearFilters } from "DMS/Controllers/listController";
export let lastActionBtnClicked;
var lastExpandedRow;
var lastSelectedRowUID;
var lastSelectedCell;
var scrollTop, scrollLeft;
export function GetKendoGrid() {
    return Seed.Tab.GetFrame().find('.k-grid[id^=grid_]');
}
export function initializeSearchKendo(pTarget) {
    // Collapse
    $(pTarget).find('.collapse').on('shown.bs.collapse', () => setGridSize()).on('hidden.bs.collapse', () => setGridSize());
}
export function addFilterTypeRecursively(filterObj, schemas) {
    if (!Array.isArray(filterObj)) {
        filterObj = [filterObj];
    }
    for (let i = 0; i < filterObj.length; i++) {
        // object filtre "simple" :
        // {field: ..., operator: ..., value: ...}
        if (typeof filterObj[i].filters == 'undefined') {
            // la propriété type (type de champ) est propre à DMS
            if (typeof filterObj[i].type == 'undefined') {
                let field = schemas.find((column) => column.field == filterObj[i].field);
                if (typeof field != 'undefined') {
                    filterObj[i].type = field.type;
                }
            }
            // objet filtre plus complexe
            // (on peut avoir autant de sous-niveaux 'filters' que nécessaire)
            // {logic: ...,
            // 	filters : [{field: ..., operator: ..., value: ...}]}
        }
        else {
            filterObj[i].filters = addFilterTypeRecursively(filterObj[i].filters, schemas);
        }
    }
    return filterObj;
}
export function setupFilterType() {
    let originalFilter = kendo.data.DataSource.fn.filter;
    kendo.data.DataSource.fn.filter = function (e) {
        if (typeof arguments[0] !== 'undefined' && arguments[0] !== null && $(this).length > 0) {
            let filterObj = arguments[0];
            let schemas = $(this)[0].options.schema.model.fields;
            filterObj = addFilterTypeRecursively(filterObj, schemas);
            return originalFilter.apply(this, filterObj);
        }
        return originalFilter.apply(this, arguments); // Il ne faut pas toucher à arguments sans raison, risque de boucle infinie, arguments est une variable composée
    };
}
/**
 * Afficher une liste
 * @param {type} nomdiv
 * @param {type} offset
 * @param {type} numaction
 * @param {type} pOrderby
 * @param {type} pImport
 */
export function rqListKendo(nomdiv, offset, numaction, pOrderby, pImport) {
    var gridExists = (GetKendoGrid().length !== 0);
    if (gridExists) {
        var datasource = GetKendoGrid().data("kendoGrid").dataSource;
        var filters = [];
        if (datasource.filter()) {
            filters = datasource.filter().filters;
        }
        var searchform = Seed.Tab.GetFrame().find("div#recherche");
        var inputs = searchform.find("input,select");
        const regExp = /^_RECH_(.*)_[^_]*$/;
        for (var i = 0; i < inputs.length; i++) {
            // getting the name of the column in the database
            // from the string : '_RECH_column_xxx'
            const fieldId = $(inputs[i]).attr("id");
            const matches = regExp.exec(fieldId);
            let field = matches[1];
            var value = $(inputs[i]).val();
            var imADate = false;
            if ($(inputs[i]).hasClass('SM-datepicker') && value.length !== 0) {
                value = moment.utc(value, 'L');
                imADate = true;
            }
            var operator = $(inputs[i]).attr('data-operator');
            var table = $(inputs[i]).attr('data-table');
            var type = $(inputs[i]).data("typechamp");
            if (value) {
                field = table + "." + field;
                var found = false;
                for (var j = 0; j < filters.length; j++) {
                    if (imADate) {
                        if (field.endsWith("last")) {
                            field = field.slice(0, -4);
                        }
                        //Dans la condition ici je reformatte la date pour avoir juste le jour de testé dans la condition car parfois l'heure vient foutre la *****
                        if (filters[j].field === field
                            && filters[j].operator === operator
                            && filters[j].value.toString().split(' GMT')[0].slice(0, -9) === value._d.toString().split(' GMT')[0].slice(0, -9)) {
                            found = true;
                            imADate = false;
                            break;
                        }
                    }
                    else {
                        if (field.endsWith("last")) {
                            field = field.slice(0, -4);
                        }
                    }
                    if (filters[j].field === field
                        && filters[j].operator === operator
                        && (filters[j].value === value
                            // pb avec la manipulation des chaines de type "0" dans kendo :
                            // on part avec une valeur sous forme de chaine de caracteres ($this->dataSource->addFilterItem(...))
                            // et on recupere (GetKendoGrid().data("kendoGrid").dataSource.filter.filters) un nombre
                            || (filters[j].value == value && filters[j].value !== "" && value !== ""
                                && typeof filters[j].value != "boolean" && typeof value != "boolean"))) {
                        found = true;
                        break;
                    }
                }
                if (!found) {
                    filters.push({
                        "field": field,
                        "operator": operator,
                        "value": value,
                        "type": type
                    });
                }
            }
        }
        var currentPage = datasource.page();
        datasource.page(currentPage);
        toggleColumnFilter();
    }
    else {
        if (!offset) {
            offset = -1;
        }
        Seed.Tab.SetOffset(offset);
        var elements = "";
        var searchform = Seed.Tab.GetFrame().find("div#recherche");
        if (searchform.lenght !== 0 && searchform.lenght !== undefined) {
            var inputs = searchform.find("input,select");
            for (var i = 0; i < inputs.length; i++) {
                var field = $(inputs[i]).attr("id").split('_')[2];
                var value = $(inputs[i]).val();
                if ($(inputs[i]).hasClass('SM-datepicker') && value.length !== 0) {
                    value = moment.utc(value, 'L').format("YYYY/MM/DD");
                }
                if (value) {
                    elements += "&" + field + "=" + encodeURIComponent(value);
                }
            }
        }
        // Récuperer Liste de valeurs des champs Filtrer!= null
        // et alimenter la combo.
        var sImport = "";
        if (pImport) {
            var pImportLength = pImport.length;
            for (var i = 0; i < pImportLength; i++) {
                pImport[i][1] = decodeParam(pImport[i][1]);
                value = pImport[i][1];
                if (value) {
                    sImport += "&" + pImport[i][0] + "=" + encodeURIComponent(value);
                }
            }
        }
        var div;
        var offsetTop;
        if (nomdiv === "mydiv")
            div = Seed.Tab.SearchNode(nomdiv, "DIV");
        if (!div)
            offsetTop = 0;
        else
            offsetTop = div.offsetTop;
        var orderBy = "";
        if (pOrderby) {
            orderBy = pOrderby;
            Seed.Tab.SetOrder(pOrderby);
        }
        else
            orderBy = Seed.Tab.GetOrder();
        var urlEnding = "_module/ListAndForm/ListKendoController.php";
        var windowHeight = window.innerHeight;
        var frameHeight = parseInt($('body').css('padding-top')) + parseInt(Seed.Tab.GetFrame().css('padding-top')) + parseInt(Seed.Tab.GetFrame().children().children(':first-child').css('height')) + 22 + 45 + 50 + 30.5;
        frameHeight += typeof Seed.Tab.GetFrame().find('div[id^="listSearch"]').css('height') !== 'undefined' ? parseInt(Seed.Tab.GetFrame().find('div[id^="listSearch"]').css('height')) : 0;
        var nbOfRows = Math.floor((windowHeight - frameHeight) / 42);
        if (typeof InstallTrigger !== 'undefined')
            nbOfRows -= 1;
        Seed.Ajax.Post({
            url: root + urlEnding,
            data: "typeRequest=grid"
                + sImport
                + "&nomdiv=" + nomdiv
                + "&numaction=" + numaction
                + "&offset=" + offset
                + elements
                + sImport
                + "&orderBy=" + orderBy
                + "&Top=" + offsetTop
                + "&moduleType=" + moduleType
                + "&nbOfRows=" + nbOfRows,
            json: true,
            async: true,
            success: function (xml) {
                // clear
                $(div).html("");
                // SQL
                var divError = '<div class="alert alert-info" style="display:none">';
                var spanError = '<span></span>';
                var alertError = '<div class="space alert alert-danger" role="alert" style="display:none"><span class="fa fa-exclamation-circle" aria-hidden="true"></span></div></div>';
                $(div).append(divError + spanError + alertError);
                // Kendo
                $(div).append(xml.html);
                // Script
                var jscript = document.createElement("SCRIPT");
                jscript.text = xml.jscript;
                Seed.Tab.GetFrame().append(jscript);
                Seed.Tab.GetFrame().on("dms:gridReady", (e) => {
                    // Addon
                    manageCheckbox();
                    let originalBtnCounter = 0;
                    if (typeof Seed.Tab.GetFrame().find('.buttonBar').children() !== 'undefined')
                        originalBtnCounter = Seed.Tab.GetFrame().find('.buttonBar').children().length;
                    if (xml.exportCSV) {
                        addExportCsvBtn();
                    }
                    // Redimensionnement de la grille
                    if (originalBtnCounter !== 0 && xml.exportCSV)
                        setGridSize(undefined, false);
                    else
                        setGridSize(undefined, true);
                    resizeScreen();
                    setupFilterType();
                });
            }
        });
    }
}
// Calcul du nombre de ligne dans une KendoGrid
export function autoPageSize() {
    var nomGrid = $('.k-grid:visible').attr("id");
    if (typeof nomGrid !== "undefined") {
        var grid = $("#" + nomGrid); //On recupere l'instance de liste kendo courante
        if (grid !== null) {
            var gridContent = $(grid).find('.k-grid-content'); //Contenue de la liste
            if (gridContent !== null) {
                var gridLine = $(gridContent).find('tr:first'); //Premiere ligne
                if (gridLine.length !== 0) {
                    var windowHeight = window.innerHeight; // window's height..
                    var frameHeight = parseInt($('body').css('padding-top')) + parseInt(Seed.Tab.GetFrame().css('padding-top')) //Tab's padding
                        + parseInt(Seed.Tab.GetFrame().children().children(':first-child').css('height')) //First panel's element's height
                        + 22 + 45 + 50 + 30.5; //CST: 22 for panel's margin bot, 45 pager's height, 50 for body margin bot, 30.5 for grid header
                    frameHeight += typeof Seed.Tab.GetFrame().find('div[id^="listSearch"]').css('height') !== 'undefined' ? parseInt(Seed.Tab.GetFrame().find('div[id^="listSearch"]').css('height')) : 0;
                    if (Seed.Tab.GetFrame().find('.k-footer-template').css('height') !== undefined)
                        frameHeight += parseInt(Seed.Tab.GetFrame().find('.k-footer-template').css('height'));
                    var nbOfRows = Math.floor((windowHeight - frameHeight) / 42);
                    if (typeof InstallTrigger !== 'undefined')
                        nbOfRows -= 1;
                    if (nbOfRows > 0) {
                        var data = $(grid).data("kendoGrid"); //Data de la liste
                        if (data !== null) {
                            if (data.dataSource.pageSize() !== 25 && data.dataSource.pageSize() !== 50 && data.dataSource.pageSize() !== 100) { //Si le nombre d'element actuellement affiché est different du nouveau
                                var pageNum = data.dataSource.page(); //On recupere le numero de page a laquelle on est
                                GetKendoGrid().children('.k-grid-content').css('height', 42 * nbOfRows + 25 + 'px');
                                data.dataSource.pageSize(nbOfRows); //Refresh de la liste avec le nombre de ligne affichable
                                var optionToChange = Seed.Tab.GetFrame().find('.k-pager-sizes.k-label').children().children('select').children(':first-child');
                                optionToChange[0].innerHTML = nbOfRows;
                                optionToChange[0].value = nbOfRows;
                                if (data.dataSource.page() !== pageNum) { //Si le changement du nombre de ligne par page a changé le numero de page
                                    data.dataSource.page(pageNum); //On replace la liste a la page precedement definit
                                }
                                data.refresh();
                            }
                        }
                    }
                }
            }
        }
    }
}
export function save(e) {
    var nomChamp = Object.keys(e.values)[0];
    var valeur = e.values[nomChamp];
    var container = e.container[0];
    if ($(container).is('button')) {
        container = $(container).closest('td');
    }
    var datetype = $(container).attr('data-type');
    if (datetype === "pourcentage") {
        valeur = valeur / 100;
    }
    else if (datetype === "date") {
        valeur = moment(valeur).format("YYYY-MM-DD");
    }
    else if (datetype === "dateheure") {
        valeur = moment(valeur).format("YYYY-MM-DD HH:mm:ss");
    }
    else if (datetype === "heure" || datetype === "duration") {
        valeur = moment(valeur).format("HH:mm:ss");
    }
    var bbmindex = e.model.bbmindex;
    var table = $(container).attr('data-table');
    var containerAttributes = $(container).closest('tr').find('td[data-export]');
    var sExport2 = containerAttributes.attr('data-export');
    if (typeof sExport2 === 'undefined') {
        sExport2 = '';
    }
    var tr = $(container).closest('tr');
    var indexModifier = 0;
    let trIndex = 0;
    $(tr).prevAll('tr.k-detail-row').each(function () {
        indexModifier++;
    });
    // try to look if we're in a subrow || this strangely seems to works :)
    if (indexModifier === 0) {
        const realTr = Seed.Tab.GetFrame().find('tr.k-master-row.k-state-selected');
        if ($(realTr).prevAll('tr.k-master-row') !== undefined) {
            $(realTr).prevAll('tr.k-master-row').each(function () {
                trIndex++;
            });
        }
    }
    if (tr.length !== 0 && sExport2 !== '') {
        trIndex = trIndex !== 0 ? trIndex : $(container).closest('tr')[0].rowIndex;
        if (trIndex >= 0) {
            var gridData = GetKendoGrid().data().kendoGrid.dataSource.view()[trIndex - indexModifier];
            var splittedButtonValue = sExport2.split("'", 100);
            var numberOfParam = splittedButtonValue.length;
            var toEncode = false;
            for (let i = 0; i < numberOfParam; i++) {
                //is odd
                if (i & 1) {
                    if (!toEncode) {
                        toEncode = true;
                    }
                    else {
                        var tempArray = splittedButtonValue[i].split('"');
                        if (!tempArray[0].startsWith('implicite') && tempArray[0] !== "0") {
                            var decodedParam = decodeParam(tempArray[0]);
                            if (decodedParam.startsWith('#=')) {
                                var tempParam = decodedParam.replace('#= ', '');
                                var tempParamBis = tempParam.replace(' #', '');
                                decodedParam = gridData[tempParamBis];
                            }
                            splittedButtonValue[i] = encodeParam(decodedParam);
                        }
                        toEncode = false;
                    }
                }
            }
            sExport2 = splittedButtonValue.join('"', 100);
        }
    }
    sExport2 = eval(sExport2);
    var origine = container.getAttribute('data-origine');
    var typeChamp = container.getAttribute('data-type');
    processUpdate(table, 'bbmindex', bbmindex, nomChamp, valeur, sExport2, false, origine, typeChamp, false, "list");
    // Si ligne secondaire
    if (e.container.parents("div[id^=grid]:first").attr("id").indexOf("griddetail") === 0) {
        var grid = GetKendoGrid().data("kendoGrid");
        var row = grid.tbody.children(":has(> .k-hierarchy-cell .k-i-collapse)");
        var data = grid.dataItem(row);
        data[nomChamp] = valeur;
        var columns = grid.options.columns;
        if (columns.length > 0) {
            var index = -1;
            for (var i = 0; i < columns.length; i++) {
                if (columns[i].field === nomChamp) {
                    index = i;
                    $(row.find("td")[index + 1]).text(valeur);
                    break;
                }
            }
        }
    }
    if (datetype === 'select') {
        Seed.Tab.GetFrame().find('.k-grid').data("kendoGrid").dataSource.read();
    }
}
export function edit(e) {
    // zone modifiable mais avec bouton d'action pour le rendre modifiable via l'action CSS
    var containerContext = $(e.container.context);
    if (containerContext.hasClass('not-editable')) {
        var grid = e.container.closest('.k-grid').data('kendoGrid');
        var cell = e.container;
        grid.closeCell(cell);
    }
    // pourcentage
    if (containerContext.attr('data-type') === "pourcentage") {
        var fieldname = getFieldname(e);
        e.container.find("[data-role=numerictextbox]")
            .data("kendoNumericTextBox")
            .value(e.model[fieldname] * 100);
    }
    else if (containerContext.attr('data-type') === "password") {
        e.container.find("input.k-input")
            .attr('type', 'password');
    }
    if (containerContext.is('button')) {
        e.container.parent().find('input.k-input.k-formatted-value').blur(function () {
            e.container.closest('td').addClass('not-editable');
        });
    }
    if (containerContext.children().hasClass('k-widget k-dropdown')) {
        var selectToClick = Seed.Tab.GetFrame().find('.k-select')[0];
        $(selectToClick).trigger('click');
    }
}
/**
 * Methode qui va calculer les dimensions de la grille
 * @param {string} nomGrid Id de la grille à ajuster
 * @param {bool} context Id de la grille à ajuster
 */
export function setGridSize(nomGrid, context) {
    let gridElem = GetKendoGrid();
    let grid = gridElem.data('kendoGrid');
    if (typeof grid === 'undefined')
        return;
    if (typeof nomGrid === "undefined") {
        nomGrid = gridElem.attr('id');
    }
    if (typeof context === "undefined") {
        context = false;
    }
    var height = getGridHeight(nomGrid);
    if (typeof grid !== 'undefined' && typeof grid.dataSource._aggregate !== 'undefined') {
        height -= grid.dataSource._aggregate.length !== 0 ? 34 : 0;
    }
    if (context) {
        let currentPageSize = grid.dataSource.pageSize();
        grid.dataSource.pageSize(currentPageSize - 1);
    }
    $("#" + nomGrid + " > .k-grid-content").first().height(height);
    $("#" + nomGrid + " > .k-grid-content-locked").first().height(height);
}
/**
 * Methode pour calculer la taille des elements autres que la grille
 *
 * @param {string} nomGrid est l'id du div de la grille courante
 * @returns {Number|getGridHeight.taillePage|getGridHeight.offsetTop} correspond e la taille
 * que l'on va donner e la partie contenu de la grille
 */
export function getGridHeight(nomGrid) {
    var grid = $("#" + nomGrid);
    if (grid.length !== 0) {
        var taillePage = $(window).height();
        taillePage -= $('footer>div').height();
        var offsetTop = $("#" + nomGrid).offset().top;
        var otherElements = grid.children().not(".k-grid-content,.k-grid-content-locked,.k-loading-mask");
        var otherElementsHeight = 0;
        otherElements.each(function () {
            otherElementsHeight += $(this).outerHeight();
        });
        var tailleFinale = taillePage - offsetTop - otherElementsHeight - 15;
        return tailleFinale;
    }
}
export function timeEditor(container, options) {
    $('<input data-text-field="' + options.field + '"'
        + ' data-value-field="' + options.field + '"'
        + ' data-bind="value:' + options.field + '"'
        + ' data-format="' + options.format + '"/>')
        .appendTo(container)
        .kendoTimePicker({});
}
export function dateTimeEditor(container, options) {
    $('<input data-text-field="' + options.field + '"'
        + ' data-value-field="' + options.field + '"'
        + ' data-bind="value:' + options.field + '"'
        + ' data-format="' + options.format + '"/>')
        .appendTo(container)
        .kendoDateTimePicker({});
}
export function dropDownEditor(container, option) {
    var column = container[0];
    var droptable = column.getAttribute('data-droptable');
    var dropfield = column.getAttribute('data-dropfield');
    var droplabel = column.getAttribute('data-droplabel');
    var dropempty = column.getAttribute('data-dropempty');
    var dropconstraint = column.getAttribute('data-dropconstraint');
    $('<input data-text-field="' + droplabel + '"'
        + ' data-value-field="' + dropfield + '"'
        + ' data-bind="value:' + option.field + '"/>')
        .appendTo(container)
        .kendoDropDownList({
        autoBind: false,
        dataSource: {
            schema: {
                data: "data"
            },
            transport: {
                read: {
                    url: root + "_module/ListAndForm/ListKendoController.php",
                    type: "POST",
                    dataType: "json",
                    data: {
                        "typeRequest": "dropdown",
                        "droptable": droptable,
                        "dropfield": dropfield,
                        "droplabel": droplabel,
                        "dropempty": dropempty,
                        "dropconstraint": dropconstraint
                    }
                }
            }
        },
        valuePrimitive: true,
        dataTextField: droplabel,
        dataValueField: dropfield
    });
}
export function multiSelectEditor(container, option) {
    let MultiSelectBootstrap = window.kendo.ui.Widget.extend({
        init: function (element, options) {
            window.kendo.ui.Widget.fn.init.call(this, element, options);
            this._dataSource();
            this.dataSource.fetch();
        },
        refresh: function () {
            let dataProcess = this.dataSource.view();
            let optionsSelect = "";
            let optionsValues = [];
            for (let index = 0, len = dataProcess.length; index < len; ++index) {
                if (dataProcess[index][this.options.dataValueField] != null) {
                    optionsValues.push({
                        value: dataProcess[index][this.options.dataValueField],
                        label: dataProcess[index][this.options.dataTextField]
                    });
                }
            }
            this.element.multiselect('dataprovider', optionsValues);
        },
        options: {
            autoBind: true,
            name: "MultiSelectBootstrap"
        },
        _dataSource: function () {
            var that = this;
            this.dataSource = window.kendo.data.DataSource.create(this.options.dataSource);
            this.dataSource.bind("change", function () {
                that.refresh();
            });
        }
    });
    window.kendo.ui.plugin(MultiSelectBootstrap);
    var column = container[0];
    var droptable = column.getAttribute('data-droptable');
    var dropfield = column.getAttribute('data-dropfield');
    var droplabel = column.getAttribute('data-droplabel');
    var dropempty = column.getAttribute('data-dropempty');
    var dropconstraint = column.getAttribute('data-dropconstraint');
    let parent = $("<div style='width: 100%;' class='input-group btn-group' />");
    parent.html("<span class='input-group-addon'><i class='fa fa-list-alt'></i></span>");
    parent.appendTo(container);
    container.css("overflow", "visible");
    let selectWidget = $('<select style="width: 100%;" class="multiselect" multiple="multiple" data-text-field="' + droplabel + '" data-value-field="' + dropfield + '" data-bind="value:' + option.field + '"/>');
    selectWidget =
        selectWidget
            .appendTo(parent)
            .multiselect({
            nonSelectedText: column.getAttribute('data-label-rien'),
            allSelectedText: column.getAttribute('data-label-tous'),
            nSelectedText: column.getAttribute('data-label-select'),
            onDropdownShow: function (event) {
                parent.find("input[type=checkbox]").on("click", function (e) {
                    e.stopPropagation();
                });
            },
            onChange: function () {
                console.log(selectWidget.val());
            }
        });
    selectWidget.kendoMultiSelectBootstrap({
        autoBind: false,
        dataSource: {
            schema: {
                data: "data"
            },
            transport: {
                read: {
                    url: root + "_module/ListAndForm/ListKendoController.php",
                    type: "POST",
                    dataType: "json",
                    data: {
                        "typeRequest": "dropdown",
                        "droptable": droptable,
                        "dropfield": dropfield,
                        "droplabel": droplabel,
                        "dropempty": dropempty,
                        "dropconstraint": dropconstraint
                    }
                }
            }
        },
        valuePrimitive: true,
        dataTextField: droplabel,
        dataValueField: dropfield
    });
}
export function dropDownFilterEditor(element) {
    var droptable = this.droptable;
    var dropfield = this.dropfield;
    var droplabel = this.droplabel;
    var dropempty = this.dropempty;
    var dropconstraint = this.dropconstraint;
    element.kendoDropDownList({
        autoBind: false,
        dataSource: {
            schema: {
                data: "data"
            },
            transport: {
                read: {
                    url: root + "_module/ListAndForm/ListKendoController.php",
                    type: "POST",
                    dataType: "json",
                    data: {
                        "typeRequest": "dropdown",
                        "droptable": droptable,
                        "dropfield": dropfield,
                        "droplabel": droplabel,
                        "dropempty": dropempty,
                        "dropconstraint": dropconstraint
                    }
                }
            }
        },
        valuePrimitive: true,
        dataTextField: droplabel,
        dataValueField: dropfield
    });
}
export function textareaEditor(container, options) {
    $('<textarea'
        + ' class="kendo-textarea"'
        + ' data-bind="value: ' + options.field + '"'
        + '></textarea>')
        .appendTo(container);
}
export function textAreaTooltip() {
    let grid = Seed.Tab.GetFrame().find('[id^="grid_"]');
    $(grid).kendoTooltip({
        filter: "[data-textarea='true']",
        position: "bottom",
        content: (e) => e.target[0].textContent
    }).data("kendoTooltip");
}
export function resizeScreenKendo() {
    // Resize globale
    $.each(Seed.Tab.GetFrame(".k-grid[id^=grid_]"), (key, item) => {
        var id = $(item).attr("id");
        setGridSize(id);
        autoPageSize();
    });
}
export function destroyGrid(idTab) {
    var grid = $("#tab_" + idTab + " .k-grid");
    if (grid.length !== 0) {
        grid.data("kendoGrid").destroy();
    }
}
export function getFieldname(e) {
    var cell = e.container;
    var grid = e.container.closest('.k-grid').data("kendoGrid");
    var row = cell.closest("tr");
    var body;
    var header;
    if (cell.closest(grid.lockedContent).length) {
        body = grid.lockedContent;
        header = grid.lockedContent;
    }
    else {
        body = grid.tbody;
        header = grid.thead;
    }
    var columnIndex = $("td", row).index(cell);
    var columnField = header.find("th").eq(columnIndex).attr("data-field");
    var column;
    $.each(grid.columns, function () {
        if (this.field === columnField) {
            column = this;
            return false;
        }
    });
    return columnField;
}
export function saveCheckbox(e) {
    var grid = $(e).closest(".k-grid").data("kendoGrid");
    var nomChamp = $(e.parentNode).attr("data-nomchamp");
    var row = $(e).closest("tr");
    var item = grid.dataItem(row);
    var valeur = ($(e).is(":checked") ? 1 : 0);
    var bbmindex = item.bbmindex;
    var container = e;
    var table = $(e.parentNode).attr('data-table');
    var containerAttributes = $(container).parents('.k-grid').find('tr').find('td[data-export]')[0];
    let sExport2 = '';
    if (typeof containerAttributes != 'undefined') {
        sExport2 = containerAttributes.getAttribute('data-export');
    }
    var tr = row;
    if (tr.length !== 0 && sExport2 !== '') {
        var varTrIndex = $(e).closest('tr').index();
        if (varTrIndex >= 0) {
            var gridData = GetKendoGrid().data().kendoGrid.dataSource.view()[varTrIndex];
            var splittedButtonValue = sExport2.split("'", 100);
            var numberOfParam = splittedButtonValue.length;
            var toEncode = false;
            for (var i = 0; i < numberOfParam; i++) {
                //is odd
                if (i & 1) {
                    if (!toEncode) {
                        toEncode = true;
                    }
                    else {
                        var tempArray = splittedButtonValue[i].split('"');
                        if (!tempArray[0].startsWith('implicite') && tempArray[0] !== "0") {
                            var decodedParam = decodeParam(tempArray[0]);
                            if (decodedParam.startsWith('#=')) {
                                var tempParam = decodedParam.replace('#= ', '');
                                var tempParamBis = tempParam.replace(' #', '');
                                decodedParam = gridData[tempParamBis];
                            }
                            splittedButtonValue[i] = encodeParam(decodedParam);
                        }
                        toEncode = false;
                    }
                }
            }
            sExport2 = splittedButtonValue.join('"', 100);
        }
    }
    sExport2 = eval(sExport2);
    var origine = e.parentNode.getAttribute('data-origine');
    var typeChamp = e.parentNode.getAttribute('data-type');
    processUpdate(table, 'bbmindex', bbmindex, nomChamp, valeur, sExport2, "", origine, typeChamp, false, "list");
    Seed.Tab.Reload();
}
export function manageCheckbox() {
    var grid = GetKendoGrid().data("kendoGrid");
    if (typeof grid !== 'undefined') {
        grid.tbody.on("change", "input:checkbox", function (e) {
            if ($(e.currentTarget.parentNode.parentNode).is("a")) {
                return;
            }
            var fieldname = $(e.currentTarget.parentNode).attr("data-nomchamp");
            var row = $(e.currentTarget).closest("tr");
            var item = grid.dataItem(row);
            item.set(fieldname, $(e.currentTarget).is(":checked") ? 1 : 0);
            saveCheckbox(e.currentTarget);
        });
    }
}
export function saveNumberOfDisplayedRow(e) {
    let grid = GetKendoGrid();
    let nomliste = $(grid).attr('data-nomliste');
    let input = Seed.Tab.GetFrame().find('.k-dropdown-wrap').children('.k-input')[0];
    let nbofRows = input.textContent;
    let focusElement = document.activeElement;
    let decider = $(focusElement).children('select').length;
    if ((nbofRows === '25' || nbofRows === '50' || nbofRows === '100') && typeof e !== 'undefined' && moduleType === 'ServiceMaint' && decider === 1) {
        Seed.Ajax.Post({
            url: root + "_module/ListAndForm/ListKendoController.php",
            data: "typeRequest=nbofRows"
                + "&nomliste=" + nomliste
                + "&nbofRow=" + nbofRows
                + "&moduleType=" + moduleType,
            async: true
        });
    }
    else if (typeof e !== 'undefined' && moduleType === 'ServiceMaint' && decider === 1) {
        bootbox.confirm(MSG_RESPONSIVE, function (result) {
            if (result) {
                Seed.Ajax.Post({
                    url: root + "_module/ListAndForm/ListKendoController.php",
                    data: "typeRequest=delNbofRows"
                        + "&nomliste=" + nomliste
                        + "&moduleType=" + moduleType,
                    async: true
                });
            }
        });
    }
}
// réajustement de la largeur des colonnes pour qu'elles occupent toute la
// largeur disponible du widget grid
export function setGridWidth(e) {
    var $grid = $(e.sender.element[0]);
    var $headerWrap = $grid.find('.k-grid-header-wrap');
    var $headerColgroup = $headerWrap.find('colgroup');
    var $contentColgroup = $grid.find('.k-grid-content colgroup');
    var wrapperWidth = $headerWrap.width();
    var sumColWidth = 0;
    var sumColMinimalWidth = 0;
    var widthRatio = 0;
    // sommme des largeurs des colonnes telles qu'affichées
    $headerColgroup.find('col').each(function () {
        sumColWidth += $(this).width();
    });
    widthRatio = wrapperWidth / sumColWidth;
    // somme des largeurs minimales des colonnes (paramétrées)
    $.each(e.sender.columns, function (index, column) {
        if (!column.hidden) {
            // supprime la fin de la chaine : 'px'
            sumColMinimalWidth += typeof column.width === 'string' ? parseInt(column.width.slice(0, -2)) : column.width;
            ;
        }
    });
    // nouvelle taille colonne proportionnelle à taille initiale
    if (sumColMinimalWidth < wrapperWidth) {
        $headerColgroup.find('col').each(function () {
            var $this = $(this);
            $this.width($this.width() * widthRatio);
        });
        $contentColgroup.find('col').each(function () {
            var $this = $(this);
            $this.width($this.width() * widthRatio);
        });
    }
}
export function changeUserSetting(e) {
    var that = this;
    let nomliste = e.sender.element[0].attributes["data-nomliste"].value;
    let columnData = {};
    var cancel = false;
    var oldIndex = typeof e.oldIndex !== 'undefined' ? e.oldIndex : null;
    var newIndex = typeof e.newIndex !== 'undefined' ? e.newIndex : null;
    // on ajuste la largeur des colonnes à la largeur du widget,
    // si l'action n'est pas un déplacement ou un redimensionnement
    // (cas ajout ou suppression de colonnes)
    if (typeof e.newIndex === 'undefined' && typeof e.newWidth === 'undefined') {
        setGridWidth(e);
    }
    if (typeof e.newIndex !== 'undefined') {
        let dataFirstPos = e.sender.columns[1].attributes['data-firstposition'] !== undefined ? e.sender.columns[1].attributes['data-firstposition'] : null;
        if (dataFirstPos === null)
            dataFirstPos = e.sender.columns[0].attributes['data-firstposition'] !== undefined ? e.sender.columns[0].attributes['data-firstposition'] : null;
        cancel = (e.newIndex < dataFirstPos || oldIndex < dataFirstPos || dataFirstPos === null);
    }
    if (!cancel) {
        for (var column in e.sender.columns) {
            if (e.sender.columns[column].field !== '') {
                let tempColumn = {
                    field: e.sender.columns[column].field,
                    hidden: (e.sender.columns[column].hidden !== undefined && e.sender.columns[column].hidden !== false) ? true : false,
                    width: parseInt(e.sender.columns[column].width)
                };
                columnData[column] = tempColumn;
            }
        }
        Seed.Ajax.Post({
            url: root + "_module/ListAndForm/ListKendoController.php",
            data: "typeRequest=userSetting"
                + "&columnSetting=" + JSON.stringify(columnData)
                + "&nomliste=" + nomliste
                + "&oldIndex=" + oldIndex
                + "&newIndex=" + newIndex
                + "&moduleType=" + moduleType,
            async: true
        });
    }
    else {
        setTimeout(function () {
            that.reorderColumn(e.oldIndex, e.column);
            kendoNotify(MSG_IMPOSSIBLE_ACTION + ': ' + MSG_NO_RECORD + '!', 'danger');
        });
    }
}
/**
 * Méthode pour renvoyer le template d'un fichier
 * @param {string} value est le chemin stocké dans la base du fichier
 * @returns {String}
 */
export function fichierTemplate(value) {
    var html = "";
    if (!empty(value) && (value != 'null')) {
        var fichier = encodeURIComponent(value).replace(/'/g, "%27");
        value = value.replace(/\\/g, '/');
        html = '<button type=\'button\' class=\'btn btn-primary btn-sm\''
            + '     data-toggle=\'tooltip\' title=\'' + value + '\''
            + '      onclick=\'window.open(root+&quot;download.php?file=' + fichier + '&quot;);\' >'
            + '<i class=\'fa fa-download\'></i>' + CMD_OPEN
            + '</button>';
    }
    return html;
}
/**
 * Méthode
 * @param {string} value est le chemin stocké dans la base du fichier
 * @param {string} nomChamp est le nom
 * @param {string} nomTable est le nom de la table à mettre à jour
 * @param {string} bbmindex est l'index à prendre en compte lors de
 * l'enregistrement
 * @returns {String} Bouton pour visualiser ou ajouter un fichier
 */
export function uploadFichierTemplate(value, nomChamp, nomTable, bbmindex) {
    // @todo : utiliser du DOM + onclick = event listener
    var html = '';
    if (empty(value) || value == 'null') {
        html = '<button type=\'button\' class=\'btn btn-primary btn-sm\''
            + ' onclick=\'openUploadFormModal(&quot;' + nomChamp + '&quot;, &quot;' + nomTable + '&quot;, &quot;' + bbmindex + '&quot;)\''
            + '>'
            + '<i class=\'fa fa-upload\'></i> ' + CMD_LOAD_FILE
            + '</button>';
    }
    else {
        var fichier = encodeURIComponent(value).replace(/'/g, "%27");
        value = value.replace(/\\/g, '/');
        value = encode(value);
        html = '<div class=\'btn-group\' data-toggle=\'tooltip\'>'
            + '    <button type=\'button\' class=\'btn btn-primary btn-sm\''
            + ' title=' + value + ''
            + '        onclick = \'openUploadFormModal(&quot;' + nomChamp + '&quot;, &quot;' + nomTable + '&quot;, &quot;' + bbmindex + '&quot;);\'>'
            + '           <i class=\'fa fa-pencil\'></i> ' + CMD_EDIT_FILE
            + '    </button>'
            + '    <button type=\'button\' class=\'btn btn-primary btn-sm\''
            + ' title=\'' + value + '\''
            + '        onclick=\'window.open(&quot;' + root + 'download.php?file=' + fichier + '&quot;);\' >'
            + '           <i class=\'fa fa-download\'></i> ' + CMD_OPEN_FILE
            + '    </button>'
            + '</div>';
    }
    return html;
}
// @todo : pourquoi cette fonction est dans kendoController ?
export function openUploadFormModal(nomChamp, nomTable, bbmindex) {
    Seed.Ajax.Post({
        url: root + "_module/loadUploadForm.php",
        data: "nomChamp=" + nomChamp
            + "&nomTable=" + nomTable
            + "&bbmindex=" + bbmindex,
        json: true,
        async: true,
        success: (json) => {
            $(document.body).append(json.html);
            eval(json.jscript);
            $("#uploadFile")
                .on('hidden.bs.modal', function () {
                //Lors de la fermeture de la modal, on detruit l'element Dom
                $("#uploadFile").remove();
            })
                .modal('show');
        }
    });
}
/** Methode pour ajouter une icone sur les colonnes sur lesquelles on applique
 * un filtrage ainsi que la barre de resume des filtres juste au-dessus de la grille
 */
export function toggleColumnFilter() {
    let gridElem = GetKendoGrid();
    let grid = gridElem.data("kendoGrid");
    if (typeof grid === 'undefined')
        return;
    var nomGrid = gridElem.attr("id");
    var datasource = grid.dataSource;
    var filters = datasource.filter();
    $("div#filters" + nomGrid).remove();
    if (filters !== null && typeof filters !== "undefined") {
        filters = parseFiltersDate(filters);
        Seed.Ajax.Post({
            url: root + "_module/ListAndForm/ListKendoController.php",
            json: true,
            async: true,
            data: "typeRequest=filter"
                + "&filter=" + encodeURIComponent(kendo.stringify(filters))
                + "&columns=" + JSON.stringify(datasource.transport.options.read.data.columns)
                + "&pourcentageColumns=" + JSON.stringify(datasource.transport.options.read.data.pourcentageColumns)
                + "&nomGrid=" + nomGrid,
            success: (response) => {
                if (response.label) {
                    // Barre de recherche
                    var oldBar = $("#" + nomGrid).siblings("div[id=filters" + nomGrid + "]");
                    oldBar.remove();
                    $("#" + nomGrid).before("<div id='filters" + nomGrid + "' class='alert alert-info'>"
                        + "<a type='button' class='clearFilterButton' >"
                        + "<i class=\"fa fa-remove red-remove\" style='margin-right:3px;'></i>"
                        + "</a>Filtres: "
                        + "</div>").parent().find('.clearFilterButton').click(() => clearFilters(nomGrid));
                    $("#filters" + nomGrid).append('<span class="the-labels">' + response.label + '<span>');
                    var whereConstrainte = datasource.transport.options.read.data.where !== false ? datasource.transport.options.read.data.where : "";
                    var whereSearched = response.where;
                    var operator = "";
                    if (whereConstrainte && whereSearched) {
                        operator = " AND ";
                    }
                    var where = whereConstrainte + operator + whereSearched;
                    Seed.Tab.GetFrame().find('#impliciteListeWhere').val(where);
                }
            }
        });
    }
    else {
        var whereConstrainte = datasource.transport.options.read.data.where !== false ? datasource.transport.options.read.data.where : "";
        Seed.Tab.GetFrame().find('#impliciteListeWhere').val(whereConstrainte);
    }
}
/**
 * Méthode qui va nettoyer la grille envoyée en paramètre de tous ses filtres.
 * @param {string} nomGrid ID de la grille à nettoyer
 */
export function clearFiltersKendo(nomGrid) {
    if (!nomGrid) {
        nomGrid = GetKendoGrid().attr('id');
    }
    var grid = $("#" + nomGrid).data("kendoGrid");
    grid.dataSource.filter(null);
    $("#filters" + nomGrid).remove();
    initField();
    refreshList();
}
/**
 * Méthode pour supprimer un filtre dans la grille envoyée en paramètre.
 * Ces filtres
 * peuvent avoir deux structures différentes.
 *      - filtre 1er niveau: c'est un objet qui contient un field, un operateur
 *      et une valeur
 *      - filtre 2nd niveau: c'est un objet qui contient 2 objet filtres de
 *      premier niveau
 * ainsi qu'un operateur logique ("or" ou "and") qui va relier ces deux filtres
 *
 * @param {int} indice1 est égal à -1, 0 ou 1.
 *      si = -1: cela désigne un filtre 1er niveau
 *      si = 0/1: cela désigne un filtre 2nd niveau. Soit le premier (0)
 *      soit le deuxième (1)
 * @param {int} indice2 indique l'indice du filtre concerné au premier niveau
 * @param {objet jquery} nomGrid est la grille courante
 * @returns {undefined}
 */
export function removeFilterFromGrid(indice1, indice2, nomGrid) {
    var grid = $("#" + nomGrid).data("kendoGrid");
    var filters = grid.dataSource.filter();
    var value = "";
    var field = "";
    var filterOperator = "";
    var typeChamp = "";
    var filter;
    if (indice1 === -1) {
        if (filters.filters.length > 1) {
            filter = filters.filters[indice2];
            filters.filters.splice(indice2, 1);
        }
        else {
            filter = filters.filters[0];
            filters = null;
        }
    }
    else {
        var tempfilter = null;
        if (indice1 === 0) {
            filter = filters.filters[indice2].filters[0];
            tempfilter = filters.filters[indice2].filters[1];
        }
        else {
            filter = filters.filters[indice2].filters[1];
            tempfilter = filters.filters[indice2].filters[0];
        }
        filters.filters[indice2] = tempfilter;
    }
    grid.dataSource.filter(filters);
    value = filter.value;
    field = filter.field;
    filterOperator = filter.operator;
    typeChamp = filter.typeChamp;
    clearSearchInput(field, value, filterOperator, typeChamp);
}
export function clearSearchInput(field, value, filterOperator, typeChamp) {
    var dateTypeArray = ['date', 'dateheure', 'heure', 'duration'];
    // fieldname
    if (field.indexOf('.') !== -1) {
        field = field.split('.')[1];
    }
    // value date
    if (dateTypeArray.indexOf(typeChamp) !== -1 || (typeof value === "object" && typeof value.getDate === "function")) {
        value = moment(value).format('L');
    }
    // input normal
    if (filterOperator === 'gte' || filterOperator === 'eq' || filterOperator === 'contains' || filterOperator === 'startswith' || filterOperator === 'endswith') {
        var input = Seed.Tab.GetFrame().find('[id^=_RECH_' + field + '_]');
        if (input.val() == value) {
            input.val('');
        }
    }
    else if (filterOperator === 'lte') {
        // input borne : valeur de fin
        var input = Seed.Tab.GetFrame().find('[id^=_RECH_' + field + 'last_]');
        if (input.val() == value) {
            input.val('');
        }
    }
}
// ajout d'un filtre créé à partir d'un champ de recherche d'une liste
// à la structure de filtre kendo.
// Pour tenir compte de tous les cas, on doit avoir une structure de filtre de forme :
// filterObj = {logic: 'and',
//				filters: [filterKendoObj, filterDMSObj]};
// où :
// filterKendoObj = {logic: ...,
//					 filters : [{field: ..., operator: ..., value: ...}]};
// filterDMSObj = {field: ..., operator: ..., value: ...};
export function updateSearchFilters(grid, field, operator, value, type) {
    var borne = false;
    if (field.endsWith("last")) {
        borne = true;
        if (!field.endsWith("datefin")) {
            field = field.slice(0, -4);
        }
    }
    var newFilter = { field: field, operator: operator, value: value, type: type };
    var dataSource = grid.data("kendoGrid").dataSource;
    let filterObj = dataSource.filter();
    // il n'y a aucune structure contenant des filtres
    // => on crée une structure filtre par défaut
    if (filterObj == null) {
        filterObj = {
            logic: 'and',
            filters: null
        };
    }
    else {
        // on a un objet filtres simple :
        // filterObj = {field: ..., operator: ..., value: ...};
        // ou un tableau contenant plusieurs de ces filtres
        if (typeof filterObj.filters == 'undefined' || filterObj.logic != 'and') {
            if (!Array.isArray(filterObj)) {
                filterObj = [filterObj];
            }
            filterObj = {
                logic: 'and',
                filters: filterObj
            };
        }
    }
    let filters = filterObj.filters;
    if (filters == null) {
        if (value) {
            filters = [newFilter];
        }
    }
    else {
        var isNew = true;
        var index2delete = null;
        for (let index = 0; index < filters.length; index++) {
            if (filters[index].field == field && filters[index].operator == operator) {
                isNew = false;
                index2delete = index;
                break;
            }
        }
        if (isNew && value !== null) {
            filters.push(newFilter);
        }
        else {
            if (value) {
                let alreadyExists = false;
                for (let filt in filters)
                    if (filters[filt].field === newFilter.field && filters[filt].operator === newFilter.operator && filters[filt].value === newFilter.value)
                        alreadyExists = true;
                    else if (filters[filt].field === newFilter.field && filters[filt].operator === newFilter.operator && filters[filt].value !== newFilter.value) {
                        filters[filt].value = newFilter.value;
                        alreadyExists = true;
                    }
                if (!alreadyExists)
                    filters.push(newFilter);
            }
            else if (index2delete !== null) {
                filters.splice(index2delete, 1);
            }
        }
    }
    filterObj.filters = filters;
    dataSource.filter(filterObj);
}
export function changeFilterKendo(event, input) {
    if ((event.type === "keypress") && (event.keyCode !== 13)) {
        return 0;
    }
    let regExp = /^[^_]*_[^_]*_(.*)_[^_]*$/;
    let fieldId = $(input).attr("id");
    let matches = regExp.exec(fieldId);
    let field = matches[1];
    let operator = $(input).attr('data-operator');
    let table = $(input).attr('data-table');
    let type = $(input).data('typechamp');
    let value;
    if (typeof $(input).data("DateTimePicker") !== "undefined") {
        if ($(input).val() !== '') {
            let datePickerValue = $(input).data("DateTimePicker").date();
            if (datePickerValue != null)
                value = datePickerValue.toDate();
        }
        else {
            value = null;
        }
    }
    else {
        value = $(input).val();
    }
    let fieldname = table + "." + field;
    updateSearchFilters(GetKendoGrid(), fieldname, operator, value, type);
}
export function refreshListKendo() {
    var grid = GetKendoGrid().data("kendoGrid");
    grid.refresh();
}
//--- Parse Filter -----------------------------------------------------------//
export function parseFiltersDate(filters) {
    var globalLogic = "";
    var newFilters = [];
    for (var i = 0; i < filters['filters'].length; i++) {
        var filter = filters.filters[i];
        if (filter.logic) {
            var parse = parseFiltersDate(filter);
            newFilters.push(parse);
        }
        else {
            var parse = parseSimpleFilter(filter);
            newFilters.push(parse);
        }
    }
    globalLogic = { "logic": filters['logic'], "filters": newFilters };
    return globalLogic;
}
export function parseSimpleFilter(filter) {
    // Parse Date sur filter[value]
    var value;
    if (typeof filter.value === "object" && filter.value !== null) {
        if (typeof filter.value.setDate === "function") {
            value = {
                "field": filter.field,
                "operator": filter.operator,
                "value": moment(filter.value).format("YYYY-MM-DD"),
                "type": filter.type
            };
        }
    }
    else {
        value = filter;
    }
    return value;
}
export function detailExpand(e) {
    this.collapseRow(this.tbody.find(' > tr.k-master-row').not(e.masterRow));
    Seed.Tab.GetFrame().find('.k-master-row.k-state-selected').removeClass('k-state-selected');
    Seed.Tab.GetFrame().find(e.masterRow).addClass('k-state-selected');
}
export function dataBound(e) {
    var grid = GetKendoGrid().data('kendoGrid');
    if (typeof grid === 'undefined')
        return;
    var items = e.sender.items();
    // if the column 'grid_row_styling_class' exists,
    // its value is added as a class to the current item
    // (which is a grid row)
    if (typeof items[0] !== 'undefined') {
        var dataItem = grid.dataItem(items[0]);
        if (typeof dataItem.grid_row_styling_class !== 'undefined') {
            items.each(function (index) {
                dataItem = grid.dataItem(this);
                this.className += ' ' + dataItem.grid_row_styling_class;
            });
        }
    }
    if (lastExpandedRow) {
        var dataItem = grid.dataSource.get(lastExpandedRow);
        if (dataItem) {
            grid.expandRow("tr[data-uid=" + dataItem.uid + "]");
        }
        lastExpandedRow = undefined;
    }
    toggleColumnFilter();
    // reselect
    if (lastSelectedRowUID) {
        var row = grid.dataSource.get(lastSelectedRowUID);
        if (row) {
            var uid = row.uid;
            var line = GetKendoGrid().find("tr[data-uid='" + uid + "']");
            grid.select(line);
            if (lastSelectedCell) {
                var cell = line.find(">td:nth-child(" + (lastSelectedCell + 1) + ")");
                this.current(cell);
                this.table.focus();
                lastSelectedCell = undefined;
            }
        }
        lastSelectedRowUID = undefined;
    }
    GetKendoGrid().find('.k-grid-content').scrollTop(scrollTop);
    GetKendoGrid().find('.k-grid-content').scrollLeft(scrollLeft);
    var isSQLVisible = grid.dataSource.transport.options.read.data.isSQLVisible;
    if (isSQLVisible) {
        showSQL();
    }
    setGridSize();
}
export function showSQL() {
    var grid = GetKendoGrid();
    var query = grid.data("kendoGrid").dataSource.transport.options.read.data.query;
    var sqlPart = grid.parent().children('.alert.alert-info').children('span');
    sqlPart.text(query);
    sqlPart.parent().show();
}
export function showError(error) {
    var grid = GetKendoGrid();
    showSQL();
    var errorPart = grid.parent().children(".alert.alert-info").find('.alert.alert-danger');
    errorPart.children('span').text(error);
    errorPart.show();
}
export function dataBinding(e) {
    var grid = GetKendoGrid().data("kendoGrid");
    if (typeof grid === 'undefined')
        return;
    let pagerSizes = Seed.Tab.GetFrame().find('.k-pager-sizes');
    if (pagerSizes.length > 0)
        pagerSizes[0].setAttribute('onchange', saveNumberOfDisplayedRow(e));
    // last expanded
    var row = grid.tbody.children(":has(> .k-hierarchy-cell .k-i-collapse)");
    if (row.length) {
        lastExpandedRow = grid.dataItem(row).id;
    }
    // last selected
    if (grid.select().length > 0) {
        lastSelectedRowUID = grid.dataItem(grid.select()).id;
    }
    lastSelectedCell = grid.current();
    if (lastSelectedCell) { //On cherche la celulle selectionne sur la ligne principale
        lastSelectedCell = lastSelectedCell.index();
    }
    scrollTop = GetKendoGrid().find('.k-grid-content').scrollTop();
    scrollLeft = GetKendoGrid().find('.k-grid-content').scrollLeft();
    //Gestion de la modal d'upload si ouverte
    var modaleUpload = $('.modaleUpload');
    if (modaleUpload.length > 0) {
        modaleUpload.find('.close:first').click();
    }
}
export function addExportCsvBtn() {
    // http://jsfiddle.net/JQPurfect/5wZ3R/12/
    var btnBar = Seed.Tab.GetFrame().find(".buttonBar");
    $(btnBar).parent().show();
    if (btnBar.length > 0) {
        btnBar.children('.exportCSV').remove();
        //Bouton
        var btn = $('<button>');
        btn.attr('type', 'button');
        btn.attr('class', 'btn btn-primary btn-csv');
        btn.attr("onclick", "exportCSV()");
        btn.text(CMD_EXPORT_CSV);
        btn.appendTo(btnBar);
        //Icone
        var icon = $('<i>');
        icon.attr('class', 'fa fa-file-text-o');
        icon.prependTo(btn);
    }
    else {
        var btnBar = GetKendoGrid().parent().parent().parent().find(".buttonBar");
        if (btnBar.children().length === 0) {
            $(btnBar).remove();
        }
    }
}
export function exportCSV() {
    let grid = GetKendoGrid();
    let nomListe = grid.attr('data-nomliste');
    let url = root + "_module/exportCsv.php";
    let filter = '';
    let logic = '';
    let datasource = grid.data("kendoGrid").dataSource;
    if (typeof datasource._filter === 'undefined' || datasource._filter === null) {
        filter = null;
        logic = null;
    }
    else {
        filter = datasource._filter.filters;
        logic = datasource._filter.logic;
    }
    /*
        stringify retire les informations de fuseau horaire pour les dates
        les dates sont ensuite placé sur Greenwich, ce qui va les décaler de 1h
        rendant fausses la plupart des dates, vu qu'elles sont à minuit
    */
    let toJson = Date.prototype.toJSON;
    Date.prototype.toJSON = Date.prototype.toString;
    let arg = "query=" + datasource.transport.options.read.data.query
        + "&nomListe=" + nomListe
        + "&filter=" + encodeURIComponent(JSON.stringify(datasource.filter()))
        + "&columns=" + JSON.stringify(datasource.transport.options.read.data.columns);
    let link = url + "?" + arg;
    Date.prototype.toJSON = toJson;
    open(link, "_blank");
}
export function buttonTrashManagment(button) {
    rebuildProcess(button, true);
    confirmAction(MSG_CONFIRM_DELETE, function (result) {
        if (result === true) {
            eval(window.newProcess);
        }
        delete window.newProcess;
    });
}
export function rebuildProcess(button, fromCallback) {
    var thisGrid = Seed.Tab.GetFrame().find('[id^="grid_"]')[0];
    var closestTr = $(button).closest('tr')[0];
    var isExistSecondaryGrid = Seed.Tab.GetFrame().find('div[id^="griddetail"]');
    var classToCheck = '';
    var indexToAdd = 0;
    var trIndex = 0;
    var remove = true;
    if (typeof isExistSecondaryGrid !== "undefined" && isExistSecondaryGrid.length !== 0) {
        classToCheck = 'tr.k-master-row.k-state-selected';
        if ($(closestTr).siblings().length === 0) {
            //Ici, on clique sur un bouton en liste secondaire
            //On récupère la row qui contient le bouton/champ
            closestTr = $(closestTr).closest('.k-detail-row');
            indexToAdd = $(closestTr).prevAll('.k-detail-row').length;
            //On récupère l'index du master-row et le le master row
            let masterRow = $(closestTr).closest('.k-detail-row')[0].previousElementSibling;
            trIndex = masterRow.rowIndex;
            Seed.Tab.GetFrame().find('tr.k-state-selected').each(function () {
                $(this).removeClass('k-state-selected');
            });
            $(masterRow).addClass('k-state-selected');
            remove = false;
        }
        else {
            // ici, on clique sur un bouton alors qu'une liste secondaire est ouverte
            $(closestTr).prevAll('tr.k-detail-row').each(function () {
                indexToAdd++;
            });
        }
    }
    else {
        classToCheck = 'tr.k-state-selected';
    }
    if (remove) {
        Seed.Tab.GetFrame().find('tr.k-state-selected').each(function () {
            $(this).removeClass('k-state-selected');
        });
    }
    $(closestTr).addClass('k-state-selected');
    var masterTrSelector = Seed.Tab.GetFrame().find(classToCheck)[0];
    if (typeof masterTrSelector !== "undefined" && trIndex !== 0) {
        trIndex = masterTrSelector.rowIndex;
    }
    else {
        trIndex = masterTrSelector.rowIndex;
    }
    var gridData = $(thisGrid).data().kendoGrid.dataSource.view()[trIndex - indexToAdd];
    var buttonValue = button.attributes['data-process'].value;
    var splittedButtonValue = buttonValue.split('"', 60);
    var numberOfParam = splittedButtonValue.length;
    var toEncode = false;
    for (var i = 0; i < numberOfParam; i++) {
        //is odd
        if (i & 1) {
            if (!toEncode) {
                toEncode = true;
            }
            else {
                var tempArray = splittedButtonValue[i].split('"');
                if (!tempArray[0].startsWith('implicite') && tempArray[0] !== "0") {
                    var decodedParam = decodeParam(tempArray[0]);
                    if (decodedParam.startsWith('#=')) {
                        var tempParam = decodedParam.replace('#= ', '');
                        var tempParamBis = tempParam.replace(' #', '');
                        decodedParam = gridData[tempParamBis] !== null ? gridData[tempParamBis] : "";
                    }
                    splittedButtonValue[i] = encodeParam(decodedParam);
                }
                toEncode = false;
            }
        }
    }
    var newProcess = splittedButtonValue.join('"', 50);
    if (!fromCallback) {
        eval(newProcess);
    }
    else {
        window.newProcess = newProcess;
    }
}
export function errorHandler(e) {
    showError(e.xhr.responseText);
}
export function encode(value) {
    if (value) {
        value = value.replace(/"/g, '\\"').replace(/'/g, "\\'");
    }
    else {
        value = '';
    }
    return value;
}
export function kendoNotify(message, notifyType = 'danger', dismiss = true) {
    if ($('div.alert[data-notify]').length === 0) {
        var options = {
            icon: 'fa fa-exclamation-triangle',
            message: message
        };
        var settings = {
            type: notifyType,
            newest_on_top: false,
            allow_dismiss: true,
            placement: {
                from: "top",
                align: "center"
            },
            animate: {
                enter: 'animated fadeInDown',
                exit: 'animated fadeOutUp'
            },
            template: '<div data-notify="container" class="col-xs-11 col-sm-3 alert alert-{0}" role="alert">' +
                '<button type="button" aria-hidden="true" class="close" data-notify="dismiss">×</button>' +
                '<span data-notify="icon"></span> ' +
                '<span data-notify="message">{2}</span>' +
                '<div class="progress" data-notify="progressbar">' +
                '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' +
                '</div>' +
                '<a href="{3}" target="{4}" data-notify="url"></a>' +
                '</div>'
        };
        $.notify(options, settings);
    }
}
//# sourceMappingURL=kendoController.js.map